import { TableCell, TableCellProps, Typography } from '@mui/material';
import SortByButton from 'components/ui/buttons/SortByButton';
import { ReactNode } from 'react';
import IMapper from 'utils/mappers/IMapper';

/** Маппер нужен для проверки, что переданное поле относится к данной сущности */
type Props<M extends Model, D extends ModelDTOResponse> = TableCellProps & {
  sortableByField?: string;
  mapper?: IMapper<M, D>;
  /** Параметр поиска, который всегда будет применяться */
  initialFilter?: LocationSearchObject;
  subtitle?: ReactNode;
};

export default function TableHeaderCell<M extends Model, D extends ModelDTOResponse>({
  children,
  sortableByField,
  initialFilter,
  subtitle,
  ...rest
}: Props<M, D>) {
  if (!children) return <TableCell />;
  const content = (
    <Typography variant="subtitle2" color="inherit" component="span">
      {children}
    </Typography>
  );
  return (
    <TableCell {...rest} color="text.secondary">
      {sortableByField ? (
        <SortByButton sortFieldName={sortableByField as string} initialFilter={initialFilter}>
          {content}
        </SortByButton>
      ) : (
        content
      )}
      {subtitle && (
        <Typography variant="subtitle2" color={(theme) => theme.palette.grey[500]} component="p" mt={0.5}>
          {subtitle}
        </Typography>
      )}
    </TableCell>
  );
}
